import React from 'react'
import { Link } from 'react-router-dom'

/** Redux **/
import { useSelector } from 'react-redux'

/** Material UI **/
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Dialog,
  DialogContent,
  DialogTitle,
  FormLabel,
  Grid,
  Typography
} from '@mui/material'

import { logInContainerStyles } from '../styles/classes/LogInClasses'
import { store } from '../store'
import { authActions } from '../store/signIn'
import { enableButtonStyle } from '../styles/mui_custom_theme'
import { useTranslation } from 'react-i18next'

import { envVariables } from '../lib/Constants'

const pjson = require('../../package.json')

export default function LogInContainer (props) {
  const currentYear = new Date().getFullYear()
  const loading = useSelector(state => state.loading.loading)
  const forceLogout = useSelector(state => state.auth.forceLogout)
  const invalidUser = useSelector(state => state.auth.invalidUser)
  const { classes } = logInContainerStyles()
  const { t } = useTranslation()
  return (
    <div>
      <CssBaseline />
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          <Box className={classes.body}>{props.children}</Box>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent="center"
          ></Grid>
        </Grid>
      </Grid>
      <Dialog
        open={forceLogout || invalidUser}
        keepMounted
        onClose={() =>
          forceLogout
            ? store.dispatch(authActions.setForceLogout())
            : store.dispatch(authActions.setInvalidUser())
        }
        classes={{ paper: classes.dialogPaper }}
        style={{ zIndex: 2000 }}
        disableAutoFocus={false}
      >
        <DialogTitle
          disableTypography={true}
          classes={{ root: classes.dialogTitle }}
        >
          {forceLogout
            ? t('sign_in.logout.title')
            : t('sign_in.invalid_user.title')}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <FormLabel className={classes.dialogContentFont}>
            {forceLogout
              ? t('sign_in.logout.message')
              : t('sign_in.invalid_user.message')}
          </FormLabel>

          <Box className={classes.dialogButtonContainer}>
            <Button
              variant="outlined"
              size="small"
              type="submit"
              style={{
                ...enableButtonStyle,
                marginRight: 0
              }}
              onClick={() =>
                forceLogout
                  ? store.dispatch(authActions.setForceLogout())
                  : store.dispatch(authActions.setInvalidUser())
              }
            >
              Ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Grid className={classes.footerContainer} container>
        <Grid item xs />
        <Grid item className={classes.signInMessageContainer}>
          <Typography
            component={'span'}
            align={'center'}
            className={classes.allRightsReservedText}
          >
            @{currentYear} {t('sign_in.messages.my_work_all_rights_reserved')}{' '}
            <Link
              to={{
                pathname: envVariables.REACT_APP_FTC_PRIVACY_POLICY_URL
              }}
              variant={'body2'}
              target={'_blank'}
              rel={'noopener noreferrer'}
              className={classes.privacyPolicyLink}
            >
              {t('sign_in.messages.privacy_policy')}
            </Link>
          </Typography>
        </Grid>
        <Grid item xs style={{ textAlign: 'right' }}>
          <Link
            className={classes.contactText}
            to={{
              pathname:
                envVariables.REACT_APP_FTC_MANAGEMENT_PORTAL_CONTACT_US_URL
            }}
            variant={'body2'}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            Contact us
          </Link>
          <Typography
            variant={'p'}
            align={'center'}
            className={classes.versionText}
          >
            &nbsp;v{pjson.version}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}
